<template>
    <div class="container">
        <div class="title is-1 has-text-centered">
            Mentee Analytics
        </div>
        <data-table 
            :rows="rows" 
            :columns="columns" 
            tableClass="table is-fullwidth is-hoverable is-striped is-bordered"
            v-on:row_click="row_click"
            v-on:block="block"
        >
        </data-table>
    </div>
</template>

<script>

import DataTable from '../../components/common/Datatable.vue'
import axios from "../../api/my-axios";
export default {
    components: {
        'data-table': DataTable
    },
    data: function () {
        return {
            columns: [
                {
                    label: 'Mentee Name',
                    field: 'user',
                    sortable: true,
                    filterable: true,
                    is_mentee: true,
                },
                {
                    label: 'No of Mentorships Applied',
                    field: 'no_of_mentorships_applied',
                    sortable: true,
                },
                {
                    label: 'Accepted Mentorships',
                    field: 'accepted_mentorships',
                    sortable: true,
                },
                // {
                //     label: 'Average duration of menteeship offered (months)',
                //     field: 'avg_duration_of_menteeship',
                //     sortable: true,
                // },
                {
                    label: 'Actions',
                    field: 'action',
                    block_button: true,
                },
                {
                    label: 'Contact Mentee',
                    field: 'contact',
                    message_button: true,
                }
            ],
            rows: []
        }
    },

    created(){
        this.all_mentees();
    },

    methods: {
        row_click: function (value) {
            console.log("value: ", value);
        },

        all_mentees() {
			axios
				.get("/api/mentee/mentee/all_mentees/")
				.then(response => {
					this.rows = response.data;
				})
				.catch(error => {
					console.error(error);
					this.errors = error.response ? error.response.data : {"detail": [error.message]};
				});
		},

        block(index) {
            axios
				.post(`/api/mentee/mentee/${this.rows[index].user.uid}/block/`, {
					  is_blocked: !this.rows[index].is_blocked,
				})
				.then(_ => {
                    // var row = this.rows[index]
                    // row.is_blocked = !row.is_blocked;
                    // this.rows[index] = row
                    this.all_mentees()
				})
				.catch(error => {
					// this.modal_errors = error.response.data;
				});
        }
    }
};


</script>